/* eslint no-unused-vars: 0 */

import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { firebaseAuth }     from '../config';
import { Switch, Route }    from 'react-router-dom';
import { base }             from '../config';
import PrivateRoute         from './routes/PrivateRoute';
import PublicRoute          from './routes/PublicRoute';
import Header               from './Header';
import Login                from './Login';
import VisitsPage           from './VisitsPage';
import VisitsForm           from './VisitsForm';
import Register             from './Register';
import UserPage             from './UserPage';
import LocateUser           from '../helpers/LocateUser';
import styles               from '../styles/main.styl';
import loadingStyles        from '../styles/loading.styl';

class App extends Component {
  state = {
    authed: false,
    loading: true,
    user: {}
  }
  getChildContext() {
    return { user: this.state.user };
  }
  componentDidMount() {
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        base.fetch('users', { context: this }
          ).then( data => this.appendUserDataFromDb(user, data)
          ).then( data => LocateUser(data)
          ).then( data => this.addUserToState(user, data)
          ).catch( error => {
            console.log(error);
          }
        );
      } else {
        this.setState({ loading: false, authed: false, user: {} });
      }
    });
  }
  componentWillUnmount() {
    this.removeListener();
  }
  appendUserDataFromDb(user, data) {
    let dbUser = data[user.uid].info;
    dbUser = Object.assign(user, {
      first: dbUser.first,
      last: dbUser.last,
      username: dbUser.username
    });
    return dbUser;
  }
  addUserToState(data) {
    console.log(data);
    this.setState({
      loading: false,
      authed: true,
      user: data
    });
  }
  render() {
    if(this.state.loading) {
      return (
        <div className="loading-shroud">
          <img src="http://svgur.com/i/3CC.svg" />
        </div>
      );
    }
    return (
      <div className="app-content">
        <Header user={this.state.user} authed={this.state.authed} />
        <div className={styles.big}>
          <Switch>
            <Route component={Register} path="/xyz" />
            <PrivateRoute component={VisitsPage} authed={this.state.authed} user={this.state.user} location={this.props.location} path="/me" />
            <PrivateRoute component={VisitsForm} authed={this.state.authed} user={this.state.user} location={this.props.location} path="/new" />
            <PublicRoute component={Login} authed={this.state.authed} path="/login" />
            <Route component={UserPage} authed={this.state.authed} path="/:username/:panel" />
            <Route component={UserPage} authed={this.state.authed} path="/:username" />
            <Route component={VisitsPage} authed={this.state.authed} user={this.state.user} location={this.props.location} path="/" />
          </Switch>
          <div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.any,
  location: PropTypes.any,
  user: PropTypes.any
};

App.childContextTypes = {
  user: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./client/components/App.js